<template>
  <div class="page login">
    <navigation></navigation>
    <div class="section">
      <img
        class="logo"
        src="./images/logo.png"
        srcset="./images/logo@2x.png 2x, ./images/logo@3x.png 3x"
      />

      <div class="login-title">
        验证码登录
      </div>

      <form class="form" ref="form">
        <div class="form-item underline-un-focus">
          <nd-input
            v-model="form.mobile"
            name="mobile"
            type="pure-number"
            maxLength="11"
            placeholder="请输入本人实名手机号"
            @blur="mobileBlur"
            @focus="mobileFocus"
          >
          </nd-input>
        </div>
      </form>

      <nd-button
        class="btn"
        :disabled="isDisabled"
        @click="goLoginValidate"
      >登录/注册天美贷</nd-button>
    </div>

    <div class="protocol">
      <span class="text">
        <p class="indent">
          <img src="./images/circle_02.png" v-if="selected" @click="selected=false"/>
          <img src="./images/circle_01.png" v-else @click="selected=true"/>
        </p>
        <div>
          <span>点击「登录/注册」按钮前请先阅读并同意</span>
          <span class="active" @click="routerToLoginProtocol">《用户注册及服务协议》</span>
          <span class="active" @click="routerToPrivacyProtocol">《隐私政策》</span>
        </div>
      </span>
    </div>
  </div>
</template>
<script>
import { mapActions, mapMutations } from 'vuex'
import validate from '../../components/nd-validate'

export default {
  name: 'login',

  data () {
    return {
      form: {
        mobile: ''
      },
      rules: {
        mobile: [
          {
            require: true,
            message: '请输入手机号',
            trigger: 'blur'
          },
          {
            regular: /^1[0-9]{10}$/,
            message: '手机号码格式错误，请重新输入',
            trigger: 'blur'
          }
        ]
      },
      isDisabled: true,
      selected: this.$route.query.selected === 'T'
    }
  },

  mixins: [validate],
  methods: {
    ...mapActions('user', ['loginBySmsX']),
    ...mapMutations('user', ['setUserInfo']),

    readProtocolAction () {
      this.isReadProtocol = !this.isReadProtocol
      this.$report({
        id: 10018,
        args: { status: this.isReadProtocol ? 1 : 0 }
      })
    },

    goLoginValidate () {
      if (this.selected) {
        // 点击获取验证码
        this.$report({
          id: '10017'
        })
        this.$router.push({
          path: '/user/login/validate',
          query: {
            mobile: this.form.mobile,
            from: this.$route.query.from
          }
        })
      } else {
        this.$message('请先阅读并同意相关协议')
      }
    },

    routerToLoginProtocol () {
      this.routerToProtocol('/tmd/protocol/login')
    },

    routerToPrivacyProtocol () {
      this.routerToProtocol('/protocol/h5/privacy')
    },

    mobileBlur () {
      this.$report({
        id: 10068,
        args: {
          status: 0
        }
      })
      if (this.form.mobile) {
        const isPass = this.validateWithoutTip(this.rules)
        this.$report({
          id: 10069,
          args: {
            status: isPass ? 1 : 0
          }
        })
      }
    },

    mobileFocus () {
      this.$report({
        id: 10068,
        args: {
          status: 1
        }
      })
    }
  }
}
</script>
<style lang="less">
@import "../../assets/less/mixin.less";

.page.login {
    display: flex;
    flex-direction: column;
    .section {
        flex: 1;
        .logo {
            display: block;
            width: 140px;
            height: 140px;
            margin: 140px auto 50px;
        }

        .login-title {
            text-align: center;
            font-size: 38px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            line-height: 53px;
        }

        .form {
            padding: 0 50px;
            margin-top: 93px;

            .form-item {
                .nd-input {
                    margin-bottom: 8px;
                }
            }
        }

        .btn {
            margin: 0 auto;
            margin-top: 120px;
        }
    }

    .protocol {
        line-height: 32px;
        font-size: 24px;
        padding: 0 50px;
        margin-bottom: 85px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;

        .text {
            display: flex;
            position: relative;
            color: @fc3;
        }

        .indent {
            display: flex;
            display: inline-block;
            align-items: center;
            padding-left: 15px;
            >img{
                width:32px;
                height:32px;
                margin-right:8px;
            }
        }

        .active {
            color: #8eb2d8;
        }
    }
    .tips-content {
        padding: 20px 50px 70px;
        .header {
            font-size: 42px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(51, 51, 51, 1);
            line-height: 59px;
        }
        .body {
            margin-top: 26px;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 40px;
            .highlight {
                color: #8eb2d8;
            }
        }
        .footer {
            display: block;
            width: 460px;
            height: 80px;
            line-height: 80px;
            margin: 90px auto 0;
        }
    }
}
</style>
